"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _Heading = require("../Heading/Heading.styles");
const parts = ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'];
const baseStyle = {
  table: {
    borderCollapse: 'collapse',
    color: 'text.primary.light',
    width: '100%'
  },
  thead: {
    borderBottom: '1px',
    borderColor: 'gray.medium'
  },
  th: {
    fontFamily: 'heading',
    fontSize: _Heading.variants.h4.fontSize,
    fontWeight: 'semibold',
    letterSpacing: 'unset',
    padding: 4,
    textAlign: 'start',
    textTransform: 'none'
  },
  tr: {
    borderBottom: '1px',
    borderColor: 'gray.medium',
    _last: {
      border: 'none'
    }
  },
  td: {
    padding: 4,
    textAlign: 'start'
  }
};
const roundedWhiteVariant = {
  table: {
    backgroundColor: 'background.white',
    borderRadius: 6,
    boxShadow: 'md',
    marginBottom: 1
  }
};
const roundedGrayVariant = {
  table: {
    ...roundedWhiteVariant.table,
    backgroundColor: 'background.gray'
  }
};
const variants = exports.variants = {
  rounded: roundedWhiteVariant,
  roundedGray: roundedGrayVariant
};
const defaultProps = {
  variant: 'rounded'
};
var _default = exports.default = {
  parts,
  variants,
  baseStyle,
  defaultProps
};